import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import FillArea from "../../../../lib/html5-software-library/src/ranj/layout/FillArea";
import LayoutManager from "../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import ScreenNavigator from "../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator";

export default class ClickEaterFactory {
    /**
     * @constructor
     * @param {ScreenNavigator} screenNavigator 
     * @param {LayoutManager} layoutManager 
     */
    constructor(screenNavigator, layoutManager) {
        this._screenNavigator = screenNavigator;
        this._layoutManager = layoutManager;
    }

    static eatClick() { };

    /**
     * Creates a screen filling shape that eats clicks.
     * @returns {createjs.Shape}
     */
    createClickEater() {
        const screenWidth = this._screenNavigator.getScreenWidth();
        const screenHeight = this._screenNavigator.getScreenHeight();

        // We create a separate shape for the hit area of the click eater.
        // This way we can have a fully invisible hit area (instead having to deal with 1% alpha).
        const hitArea = new createjs.Shape();
        hitArea.graphics = hitArea.graphics.beginFill('rgba(0, 255, 0, 1)')
            .drawRect(0, 0, screenWidth, screenHeight);

        const clickEater = new createjs.MovieClip();

        clickEater.setBounds(0, 0, screenWidth, screenHeight);
        clickEater.regX = screenWidth * .5;
        clickEater.regY = screenHeight * .5;

        clickEater.addEventListener('click', ClickEaterFactory.eatClick);

        clickEater.hitArea = hitArea;

        return clickEater;
    }

    /**
     * Creates a screen filling shape that eats clicks.
     * @param {createjs.MovieClip} skin The skin to which the click eater will be added as child.
     * @param {boolean} overlay Whether the click eater should lay on top of the skin (true) or under the skin (false).
     * @returns {createjs.MovieClip} The click eater.
     */
    applyClickEaterLayerTo(skin, overlay = true) {
        if (skin.gotoAndStop) {
            skin.gotoAndStop(0);
        }

        const clickEater = this.createClickEater();
        if (overlay) {
            skin.addChild(clickEater);
        } else {
            skin.addChildAt(clickEater, 0);
        }

        this._layoutManager.registerObject(clickEater, Anchor.C, new FillArea(clickEater.getBounds(), FillArea.PROPORTIONAL_OUTSIDE));

        return clickEater;
    }

    /**
     * Destroys the given click eater
     * @param {createjs.Shape} clickEater
     */
    destroyClickEater(clickEater) {
        this._layoutManager.deregisterObject(clickEater);

        clickEater.removeAllEventListeners('click');
        if (clickEater.parent) {
            clickEater.parent.removeChild(clickEater);
        }
    }
}